"use strict";
var Observable_1 = require('../../Observable');
var expand_1 = require('../../operator/expand');
Observable_1.Observable.prototype.expand = expand_1.expand;
//# sourceMappingURL=expand.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/expand.js
 ** module id = 423
 ** module chunks = 9
 **/